






































































































import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import BButton from 'buefy/src/components/button/Button.vue';
import {namespace} from 'vuex-class';
import {MAFUser, Purchase, UserTransaction} from '@/store/User/types';
import * as _ from 'lodash';

// TODO: fix
/* tslint:disable:no-empty */

const userPath = 'userState';
const userNamespace = namespace(userPath);
@Component({
    components: {BButton},
})
export default class CoinBody extends Vue {
    @userNamespace.State('self') public self!: MAFUser;
    @userNamespace.State('transactions') public readonly transactions!: UserTransaction[];
    @userNamespace.Getter('getPurchase') public getPurchase: any;
    @userNamespace.Action('purchase') public purchase: any;
    public isLoading: boolean = false;
    constructor() {
        super();

    }

    public async buy(what: string) {
        this.isLoading = true;
        const {res, err} = await this.purchase({what});
        this.isLoading = false;
        if (err) {
            this.$toast.open({message: err, type: 'is-danger', position: 'is-bottom', duration: 2000});
        }
    }

    get audio(): Purchase {
        let ret = this.getPurchase('audio');
        ret = ret ? ret : new Purchase(null);
        return ret;
    }
    get video(): Purchase {
        let ret = this.getPurchase('video');
        ret = ret ? ret : new Purchase(null);
        return ret;
    }

    get hasAudio() {
        const hasAudio = _.find(this.transactions, (t: UserTransaction) => t.purchase.what === 'audio');
        return !!hasAudio;
    }

    get hasVideo() {
        const hasVideo = _.find(this.transactions, (t: UserTransaction) => t.purchase.what === 'video');
        return !!hasVideo;
    }

    get hasFirst500() {
        const hasFirst500 = _.find(this.transactions, (t: UserTransaction) => t.purchase.what === 'first500');
        return !!hasFirst500;
    }

    @Emit('rate')
    public rate() {
    }

    @Emit('gift')
    public gift() {
    }

    @Emit('redeem')
    public redeem() {
    }

    @Emit('coinPurchase')
    public coinPurchase() {
    }

    @Emit('close')
    public close() {
    }
}
